import React, { useEffect, useState } from "react";
import _ from 'underscore';
import { Form, Input, DatePicker, TimePicker, Select, Button, message } from 'antd';
import { Confirm, Understood } from '../Notification';
import moment from 'moment'
import dayTypesArray from './utils/day-type-requests/dayTypes';
import statusArray from './utils/day-type-requests/status';
import AuthLogic from '../../AuthLogic';

const { Option } = Select;

const datePickerFormat = 'yyyy-MM-DD'
const timePickerFormat = 'h:mmA';

const DayTypeRequestsCalendarGeneralForm = ({ contextMenuKey, dayTypeRequestDetails, dayTypesAll, dayTypesDayRule, ...props }) => {
  
  const [approvalNeeded,setApprovalNeeded] = useState(true);

  const { getFieldDecorator, getFieldsError, getFieldsValue } = props.form;

  const [selectedDates, setSelectedDates] = useState([]);
  const [isMultiDates, setIsMultiDates] = useState(false);
  
  const sortDates = (a,b) => {
     if( a.start.toISOString() < b.start.toISOString() ) {
       return -1
     }
     if( a.start.toISOString() < b.start.toISOString() ) {
      return 1
    }
    return 0;
  }
  
  useEffect(() => { // set form values
    const form = props.form; 
    let copySelected = [...dayTypeRequestDetails.selectedDates || []];
    let sorted = [];
    if( copySelected.length>0) {
      sorted = copySelected.sort(sortDates);
    }
    props.form.getFieldDecorator('datesSelected', { initialValue: [] });
    props.form.getFieldDecorator('dayType', { initialValue: undefined });
    props.form.getFieldDecorator('fromDate', { initialValue: null });
    props.form.getFieldDecorator('toDate', { initialValue: null });
    props.form.getFieldDecorator('fromTime', { initialValue: null })
    props.form.getFieldDecorator('toTime', { initialValue: null })

    form.setFieldsValue({
      dayType: dayTypeRequestDetails.dayTypeId ? dayTypeRequestDetails.dayTypeId : undefined,
      fromDate: dayTypeRequestDetails.fromDate ? moment(dayTypeRequestDetails.fromDate) : null,
      toDate: dayTypeRequestDetails.toDate ? moment(dayTypeRequestDetails.toDate) : null,
      fromTime: dayTypeRequestDetails.fromTime ? moment(dayTypeRequestDetails.fromTime) : null,
      toTime: dayTypeRequestDetails.toTime ? moment(dayTypeRequestDetails.toTime) : null,
      status: dayTypeRequestDetails.status ? dayTypeRequestDetails.status : 'U',
      myComment: dayTypeRequestDetails.myComment,
      statusComment: dayTypeRequestDetails.statusComment,
      datesSelected: sorted.map((event) => {return moment(event.start).format("yyyy-MM-DD")+" to "+moment(event.end).format("yyyy-MM-DD") +"\n"}).join('')
    });

   
     setSelectedDates(()=>sorted);
     setIsMultiDates(()=>dayTypeRequestDetails.isMultiDates);

  }, [dayTypeRequestDetails, dayTypesDayRule]);

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 2,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };
  const validateDayType = (form) =>{
    const dayType = form.getFieldValue('dayType');
    if(!dayType) {
      let dayTypeErrors = [];
      dayTypeErrors.push(new Error('Please input day type!'))
      form.setFields({
        dayType: {
          errors : dayTypeErrors
        }
      });
    }

  }
  const validateDates=(form)=>{
    let fromDate = form.getFieldValue('fromDate') ? form.getFieldValue('fromDate').startOf('day').clone() : null;
    let toDate = form.getFieldValue('toDate') ? form.getFieldValue('toDate').startOf('day').clone() : null;
    let fromDateErrors = [];
    if (!fromDate) {
      fromDateErrors.push(new Error('Please input start date!'));
    }
    if (fromDate && toDate && toDate.isBefore(fromDate)) {
      fromDateErrors.push(new Error('Start date cannot occur after end date!'));
    }
    if (fromDateErrors.length > 0) {
      form.setFields({
        fromDate: {
          value: fromDate,
          errors: fromDateErrors,
        }
      });
    } else {
      form.setFields({
        fromDate: {
          value: fromDate,
        }
      });
      if(toDate==null) {
        toDate = form.getFieldValue('fromDate').startOf('day').clone() 
      }
    }
    let toDateErrors = [];
    if (!toDate) {
      toDateErrors.push(new Error('Please input end date!'));
    }
    if (toDate && fromDate && fromDate.isAfter(toDate)) {
      toDateErrors.push(new Error('End date cannot occur before start date!'));
    }
    if (toDateErrors.length > 0) {
      form.setFields({
        toDate: {
          value: toDate,
          errors: toDateErrors,
        }
      });
    } else {
      form.setFields({
        toDate: {
          value: toDate,
        }
      });
      if(fromDate==null) {
        fromDate = form.getFieldValue('toDate').startOf('day').clone()
        form.setFields({
          fromDate: {
            value: fromDate,
            errors: [],
          }
        });
      }
    }
  } 


  const validateTime =(form) =>{
    const fromTime = form.getFieldValue('fromTime') ? form.getFieldValue('fromTime') : null;
    const toTime = form.getFieldValue('toTime') ? form.getFieldValue('toTime') : null;
    let fromTimeErrors = [];
    if (toTime && fromTime && toTime.isBefore(fromTime)) {
      fromTimeErrors.push(new Error('Start time cannot occur after end time!'));
    }
    if (!fromTime && toTime) {
      fromTimeErrors.push(new Error('Please choose a start time if you have an end time!'));
    }
    if (fromTimeErrors.length > 0) {
      form.setFields({
        fromTime: {
          value: fromTime,
          errors: fromTimeErrors,
        }
      });
    } else {
      form.setFields({
        fromTime: {
          value: fromTime,
        }
      });
    }

    let toTimeErrors = [];
    if (fromTime && toTime && fromTime.isAfter(toTime)) {
      toTimeErrors.push(new Error('End time cannot occur before start time!'));
    }
    if (!toTime && fromTime) {
      toTimeErrors.push(new Error('Please choose an end time if you have a start time!'));
    }
    if (toTimeErrors.length > 0) {
      form.setFields({
        toTime: {
          value: toTime,
          errors: toTimeErrors,
        }
      });
    } else {
      form.setFields({
        toTime: {
          value: toTime,
        }
      });
    }
  }

  const validateComments =(form)=>{
    let statusComment = form.getFieldValue('statusComment') || '';
    let myComment = form.getFieldValue('myComment') || '';

    

    let statusCommentErrors = [];
    if (statusComment && statusComment.length > 250) {
      statusCommentErrors.push(new Error('Maximum length is 250 characters!'))
      statusComment = statusComment.substring(0,250)
    }
    if (statusCommentErrors.length > 0) {
      form.setFields({
        statusComment: {
          value: statusComment,
          errors: statusCommentErrors,
        }
      });
    } else {
      form.setFields({
        statusComment: {
          value: statusComment.replace(/[^a-zA-Z0-9,:;\-.!@?#%|/$()& \n]/g,''),
        }
      });
    }

    let myCommentErrors = [];
    if (myComment && myComment.length > 250) {
      myCommentErrors.push(new Error('Maximum length is 250 characters!'))
      myComment = myComment.substring(0,250)
    }
    if (myCommentErrors.length > 0) {
      form.setFields({
        myComment: {
          value: myComment,
          errors: myCommentErrors,
        }
      });
    } else {
      form.setFields({
        myComment: {
          value: myComment.replace(/[^a-zA-Z0-9,:;\-.!@?#%|/$()& \n]/g,''),
        }
      });
    }
  }

  const validateForm = () => { // validates the whole form
    const form = props.form;
    validateDayType(form);
    if(!isMultiDates) {
      validateDates(form);
      validateTime(form);
    }
    validateComments(form);
  }

  const  validateHasHolidays = async (params) => {
    
    let dayTypeHasHolidays = await props.checkIfHasHolidaySchedule(params);
    
    return dayTypeHasHolidays;
  }

  const createWithValidation = async (formValues,hasHolidays) => {
    if(hasHolidays) {
      await continueCreate(formValues);
    } else {
      Confirm('key', { title: 'Validate Date', content: 'STORM was not able to validate if the selected date(s) are holiday(s). Do you want to continue?' }, async (key, value) => {
      if (value) {
        await continueCreate(formValues);
      } 
    });   
  }
  }

  const handleCreate = async () => {
    validateForm();
    const errors = {};
    // collect all fields currently in error state
    for (const [field, error] of Object.entries(getFieldsError())) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length != 0) {
      invalidForm();
      console.log('Invalid Form! ', errors);
      return;
    }
      
    let formValues = getFieldsValue()
    let dateRangeInfo ={tourCounter:0, jeCounter:0, tourApproved: 0, jeApproved:0}
    let hasHolidays = true;
    let foundDayType;
    var rules = props.getDayTypesByDayRule();
    var all = props.getDayTypesAll();

    if(rules && rules.length && rules.length > 0){
      foundDayType = rules.find(dayType => dayType.dayTypeId === formValues.dayType);
    } else {
      foundDayType = all.find(dayType => dayType.dayTypeId === formValues.dayType);
    }
    if(isMultiDates ) {
      for (let event of selectedDates) {
        let params = {dayType: formValues.dayType, fromDate: moment(event.start), toDate: moment(event.end), status: formValues.status}
        let info = await props.checkIfTourInDateRange(params);          
        if(info) {
          dateRangeInfo.tourCounter +=info.tourCounter;
          dateRangeInfo.jeCounter+=info.jeCounter;
          dateRangeInfo.tourApproved+=info.tourApproved;
          dateRangeInfo.jeApproved+=info.jeApproved;
          
        }
        let has = await validateHasHolidays(params)
        if (!has) hasHolidays = false;
      }
    } else {
      dateRangeInfo = await props.checkIfTourInDateRange(formValues);
      hasHolidays = await validateHasHolidays(formValues)
    }
    
    if (!(dateRangeInfo && (dateRangeInfo.tourCounter > 0 || dateRangeInfo.jeCounter > 0))) {
      await createWithValidation(formValues, hasHolidays);
      return;
    }
    
    if(dateRangeInfo.tourApproved>0) {
      const message = 'There are approved tours in this dates range.\nCannot fulfill this request. Please contact your manager if you have any questions'
      Understood('key', { title: 'Tours in date range', content: message },(key,value)=>{ });
      return;
    } 
    if(dateRangeInfo.jeApproved>0){
      const message =  'There are tours with approved assigments in this dates range.\nCannot fulfill this request. Please contact your manager if you have any questions'
      Understood('key', { title: 'Tours in date range', content: message },(key,value)=>{ });
      return;
    }

    if (foundDayType.allowTourScheduling) {
      await props.createDayTypeRequest(formValues);
      return;
    }

    if( formValues.status!="A") {
      await createWithValidation(formValues, hasHolidays);
      return;
    } 

    if (props.user.securityLevels.allowDeletingTour == 2) {/*No*/
      const message = 'There are tours/assignments in the date range chosen.\nCannot fulfill this request. Please contact your manager if you have any questions'
      Understood('key', { title: 'Tours in date range', content: message },(key,value)=>{ });
      
    } else {
      const message = 'There are tours/assignments in the date range chosen.\nDo you want to proceed with this request and delete the tours/assignments?'
      Confirm('key', { title: 'Tours in date range', content: message }, async (key, value) => {
        if (value) {
          await createWithValidation(formValues, hasHolidays);
        }
      });
      
    }
    
  }

 
  const continueCreate = async (formValues) => {
    if(isMultiDates) {
      await props.createMultipleDayTypeRequests(formValues);
    } else {
      await props.createDayTypeRequest(formValues);
    }
  }

  const handleUpdate = async () => {
    const errors = {};
    // collect all fields currently in error state
    for (const [field, error] of Object.entries(getFieldsError())) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      let formValues = getFieldsValue()

      let dateRangeInfo = await props.checkIfTourInDateRange(formValues);
      if (dateRangeInfo && (dateRangeInfo.tourCounter > 0 || dateRangeInfo.jeCounter > 0) && formValues.status === "A") {
        const message = 'There are tours/assignments in the date range chosen. Do you want to proceed with this request and delete the tours/assignments?'
        Confirm('key', { title: 'Tours in date range', content: message }, (key, value) => {
          if (value) {
            console.log('Success! Received values of form: ', formValues)
            props.updateDayTypeRequest(formValues, dayTypeRequestDetails.dayTypeRequestId);
          }
        });
      } else {
        console.log('Success! Received values of form: ', formValues);
        props.updateDayTypeRequest(formValues, dayTypeRequestDetails.dayTypeRequestId);
      }
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  }

  const handleDelete = () => {
    if (dayTypeRequestDetails.dayTypeRequestId) {
      props.deleteDayTypeRequest(dayTypeRequestDetails.dayTypeRequestId);
    } else {
      message.config({
        top: 150,
        duration: 5,
        maxCount: 5,
      });
      message.error('Could not perfom delete on this request');
    }
  }

  const formItemDisabledOnEdit = () => {
    //review when update enabled
    //contextMenuKey ? !AuthLogic.addDayTypeRequest(props.user) : !AuthLogic.editDayTypeRequest(props.user)

    return !contextMenuKey;
  }

  const formCommentReadOnly =() => {
    return props.user.securityLevels.remark != 3/*Edit*/
  }
  const formCommentStatusReadOnly =() => {
    return props.user.securityLevels.statusRemark != 3
  }

  const formCommentVisible =() => {
    return props.user.securityLevels.remark != 1/*None*/
  }
  const formCommentStatusVisible =() => {
    return props.user.securityLevels.statusRemark != 1
  }

  const handleApprovalNeeded = (e,t) => {
    if(t) { 
      let approvalNeeded = t.props.approvalneeded == 'true'
      setApprovalNeeded(approvalNeeded);
      if(!approvalNeeded) {
        props.form.setFields({status: {value:"A"}});
      } else {
        props.form.setFields({status: {value:"U"}});
      }
    }
    props.handleDayTypeChange(e, validateForm);
  }

  const controlButtonDisabled = {
    backgroundColor: '#f5f5f5',
    color: 'rgb(143, 143, 143)',
    cursor: 'not-allowed',
    opacity: 1,
    resize: "none",
  }
  const controlButtonEnabled = {
    resize: "none" 
  }

  return (
    <Form>
      <Form.Item
        label="Day Type"
        style={{ display: "flex", marginBottom: 5 }}
      >
        {getFieldDecorator('dayType', {
          rules: [{
            required: true, message: 'Please input a Day Type!',
          }],
        })(
          <Select
            name='dayType'
            onChange={(e,t) => {handleApprovalNeeded(e,t);}
          }
            allowClear={true}
            style={{ width: 250 }}
            dropdownStyle={{ zIndex: 2000 }}
            disabled={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
            
          >
            {dayTypesDayRule ?
              (
                dayTypesDayRule.map((dayTypeOption, index) => {
                  return <Option key={index} value={dayTypeOption.dayTypeId} approvalneeded={dayTypeOption.approvalNeeded.toString()} >{dayTypeOption.dayTypeName}</Option>
                })
              )
              :
              (
                dayTypesArray.map((dayTypeOption, index) => {
                  return <Option key={index} value={dayTypeOption.name} >{dayTypeOption.name}</Option>
                })
              )
            }
          </Select>
        )}
      </Form.Item>
      {isMultiDates &&
      <Form.Item label="Dates Selected" style={{ marginBottom: 5 }} >
         {getFieldDecorator('datesSelected', {})(
        <Input.TextArea
            name="datesSelected"
            style={{ resize: "none" }}
            size={'large'}
            readOnly ={true}
            rows = {4}
            
          />)}

      </Form.Item>}
      {!isMultiDates && 
      <Form.Item  label="From Date"style={{ marginBottom: 5 }}>
         {getFieldDecorator('fromDate', {
          rules: [
            {
              required: true,
              message: 'Please input start date!'
            },
          ],
        })(
          <DatePicker
            name="fromDate"
            // showTime={{ format: datePickerFormat, use12Hours: true }}
            onChange={(e) => props.handleFromDateChange(e, validateForm)}
            allowClear={true}
            placeholder={'Select date'}
            format={datePickerFormat}
            size={'large'}
            popupStyle={{ zIndex: 2000 }}
            disabled = {formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
          />
        )}
      </Form.Item>}
      {!isMultiDates &&
      <Form.Item
        label="To Date"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('toDate', {
          rules: [
            {
              required: true,
              message: 'Please input start date!'
            },
          ],
        })(
          <DatePicker
            name="toDate"
            //showTime={{ format: datePickerFormat, use12Hours: true }}
            onChange={(e) => props.handleToDateChange(e, validateForm)}
            allowClear={true}
            placeholder={'Select date'}
            format={datePickerFormat}
            size={'large'}
            popupStyle={{ zIndex: 2000 }}
            disabled  ={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
          />
        )}
      </Form.Item>}

      {!isMultiDates && 
      <Form.Item
        label="From Time"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('fromTime', {})(
          <TimePicker
            name="fromTime"
            onChange={(e) => props.handleFromTimeChange(e, validateForm)}
            allowClear={false}
            format={timePickerFormat}
            style={{ marginLeft: 5, marginRight: 5 }}
            popupStyle={{ zIndex: 2000 }}
            disabled ={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
            use12Hours={true}
            minuteStep={15}
          />
        )}

      </Form.Item>}
      {!isMultiDates && 
      <Form.Item
        label="To Time"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('toTime', {})(
          <TimePicker
            name="toTime"
            onChange={(e) => props.handleToTimeChange(e, validateForm)}
            allowClear={false}
            format={timePickerFormat}
            style={{ marginLeft: 5, marginRight: 5 }}
            popupStyle={{ zIndex: 2000 }}
            disabled ={formItemDisabledOnEdit() || dayTypeRequestDetails.isDayType}
            use12Hours={true}
            minuteStep={15}
          />
        )}
      </Form.Item>}
      
      {AuthLogic.viewStatus(props.user) &&
        <Form.Item
          label="Status"
          style={{ marginBottom: 5 }}
        >
          {getFieldDecorator('status', {
            rules: [{
              required: true, message: 'Please input a status!',
            }],
          })(
            <Select
              name='status'
              onChange={(e) => props.handleStatusChange(e, validateForm)}
              style={{ width: 250 }}
              dropdownStyle={{ zIndex: 2000 }}
              disabled ={ (!approvalNeeded || !AuthLogic.editStatus(props.user)) || formItemDisabledOnEdit() }
            >
              {statusArray.map((statusOption, index) => {
                return <Option key={index} value={statusOption.value} >{statusOption.name}</Option>
              })}
            </Select>
          )}
        </Form.Item>
      }

      { formCommentVisible() &&
      <Form.Item
        label="My Comment"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('myComment', {})(
          <Input.TextArea
            name="myComment"
            onChange={(e) => props.handleMyCommentChange(e, validateForm)}
            size={'large'}
            placeholder={(formItemDisabledOnEdit()|| formCommentReadOnly()) ? '' : 'Enter text here.'}
            readOnly ={formItemDisabledOnEdit()|| formCommentReadOnly()}
            style = {(formItemDisabledOnEdit()|| formCommentReadOnly()) ? controlButtonDisabled: controlButtonEnabled}
            rows = {4}
          />
        )}
      </Form.Item>
      }

      { formCommentStatusVisible() &&
      <Form.Item
        label="Status Comment"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('statusComment', {})(
          <Input.TextArea
            name="statusComment"
            onChange={(e) => props.handleStatusCommentChange(e, validateForm)}
            size={'large'}
            placeholder={(formItemDisabledOnEdit()|| formCommentStatusReadOnly()) ? '' : 'Enter text here.'}
            readOnly ={formItemDisabledOnEdit()||formCommentStatusReadOnly()}
            style = {(formItemDisabledOnEdit()|| formCommentStatusReadOnly()) ? controlButtonDisabled: controlButtonEnabled}
            rows = {4}
          />
        )}
      </Form.Item>
      }

      {contextMenuKey
        ?
        <React.Fragment>
          {AuthLogic.addDayTypeRequest(props.user) && (
            <Form.Item
              style={{ marginTop: 20 }}
            >
              <Button type="primary" size={'large'} onClick={handleCreate}>
                Create
              </Button>
            </Form.Item>
          )}
        </React.Fragment>
        :
        <React.Fragment>
          <Form.Item
            style={{ marginTop: 20 }}
          >
            {/* {AuthLogic.editDayTypeRequest(props.user) && (
              <Button type="primary" size={'large'} onClick={handleUpdate}>
                Update
              </Button>
            )} */}

            {/* {AuthLogic.removeDayTypeRequest(props.user) && dayTypeRequestDetails.status !== 'A' && (
              <Button type="danger" size={'large'} onClick={handleDelete}>
                Delete
              </Button>
            )} */}
          </Form.Item>
        </React.Fragment>
      }
    </Form>
  );
}

const WrappedDayTypeRequestCalendarForm = Form.create()(DayTypeRequestsCalendarGeneralForm);
export default WrappedDayTypeRequestCalendarForm;



// WEBPACK FOOTER //
// ./src/Components/DayType/DayTypeRequestsCalendarGeneralForm.js